// constants
import { UOMActionTypes } from './constants';
import { UOMType as UOMTypeDataType } from 'src/types/unitOfMeasurement';

export type UOMActionType = {
    type:
        | UOMActionTypes.API_RESPONSE_SUCCESS
        | UOMActionTypes.API_RESPONSE_ERROR
        | UOMActionTypes.GET_UOM
        | UOMActionTypes.ADD_UOM
        | UOMActionTypes.EDIT_UOM
        | UOMActionTypes.GET_UOMS
        | UOMActionTypes.RESET
        | UOMActionTypes.RESET_SUCCESS
        | UOMActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const UOMApiResponseSuccess = (
    actionType: string,
    data: UOMTypeDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): UOMActionType => ({
    type: UOMActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const UOMApiResponseError = (
    actionType: string,
    data: UOMTypeDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): UOMActionType => ({
    type: UOMActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addUOM = (params: any): UOMActionType => ({
    type: UOMActionTypes.ADD_UOM,
    payload: params,
});

export const editUOM = (params: any): UOMActionType => ({
    type: UOMActionTypes.EDIT_UOM,
    payload: params,
});

export const getUOM = (params: any): UOMActionType => ({
    type: UOMActionTypes.GET_UOM,
    payload: params,
});

export const getUOMs = (params: any): UOMActionType => ({
    type: UOMActionTypes.GET_UOMS,
    payload: params,
});

export const resetUOM = (): UOMActionType => ({
    type: UOMActionTypes.RESET,
    payload: {},
});

export const resetUOMSuccess = (): UOMActionType => ({
    type: UOMActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetUOMError = (): UOMActionType => ({
    type: UOMActionTypes.RESET_ERROR,
    payload: {},
});
